import vue from "../main";
import { transportType } from "../staticData/TransportTypes";

export const allTransportSettlementTypes = () => {
  let array = [];
  array.push({
    value: 1,
    text: vue.$t("$staticData.transportSettlementTypes.booking")
  });
  array.push({
    value: 2,
    text: vue.$t("$staticData.transportSettlementTypes.lumpSum")
  });
  array.push({
    value: 3,
    text: vue.$t("$staticData.transportSettlementTypes.ticketScan")
  });
  array.push({
    value: 4,
    text: vue.$t("$staticData.transportSettlementTypes.ticketLost")
  });
  array.push({
    value: 5,
    text: vue.$t("$staticData.transportSettlementTypes.companyProvided")
  });
  array.push({
    value: 6,
    text: vue.$t("$staticData.transportSettlementTypes.employeeStatement")
  });
  array = array.sort((a, b) => (a.text > b.text ? 1 : -1));
  array.push({
    value: 7,
    text: vue.$t("$staticData.transportSettlementTypes.alreadySettled")
  });
  return array;
};

export default function(transport_type) {
  let allowedTransportSettlementTypes = JSON.parse(vue.$store.state.Auth.userProperties.system_settings.allowed_transport_settlement);
  let array = [];
  if ((transport_type === transportType.TRANSPORT_FLIGHT || transport_type === transportType.TRANSPORT_RAIL) && allowedTransportSettlementTypes.includes(1)) {
    array.push({
      value: 1,
      text: vue.$t("$staticData.transportSettlementTypes.booking")
    });
  }
  if (
    (transport_type === transportType.TRANSPORT_PUBLIC_LOCAL || transport_type === transportType.TRANSPORT_OTHER) &&
    allowedTransportSettlementTypes.includes(2)
  ) {
    array.push({
      value: 2,
      text: vue.$t("$staticData.transportSettlementTypes.lumpSum")
    });
  }
  if (allowedTransportSettlementTypes.includes(3)) {
    array.push({
      value: 3,
      text: vue.$t("$staticData.transportSettlementTypes.ticketScan")
    });
  }
  if (allowedTransportSettlementTypes.includes(4) && transport_type !== transportType.TRANSPORT_CAR_RENTAL) {
    array.push({
      value: 4,
      text: vue.$t("$staticData.transportSettlementTypes.ticketLost")
    });
  }
  if (allowedTransportSettlementTypes.includes(5)) {
    array.push({
      value: 5,
      text: vue.$t("$staticData.transportSettlementTypes.companyProvided")
    });
  }
  if (allowedTransportSettlementTypes.includes(6)) {
    array.push({
      value: 6,
      text: vue.$t("$staticData.transportSettlementTypes.employeeStatement")
    });
  }
  array = array.sort((a, b) => (a.text > b.text ? 1 : -1));
  if (allowedTransportSettlementTypes.includes(7)) {
    array.push({
      value: 7,
      text: vue.$t("$staticData.transportSettlementTypes.alreadySettled")
    });
  }
  return array;
}
